import React, { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { router, routerFutureFlags } from './routes/routes';
import { resizers } from 'utils';

export function App() {
  useEffect(() => () => resizers.teardown(), []);

  return (
    <Sentry.ErrorBoundary>
      <RouterProvider future={routerFutureFlags} router={router} />
    </Sentry.ErrorBoundary>
  );
}
